import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { Avatar } from 'antd';

interface CardProfileProps {
  name: string | '';
  email: string | '';
  phone: string | '';
}

const CardProfile = ({ name, phone, email }: CardProfileProps) => {
  return (
    <section className="CardProfile">
      {/* Desktop View */}
      <div className="CardProfile__content CardProfile__content--desktop">
        <Avatar size={24} className="avatar">
          {'KS'}
        </Avatar>
        <Link className="link" to="./" 
          data-tooltip-id="loan-officer-tooltip"
          data-tooltip-html={`<span class="loan-officer">LOAN OFFICER</span><br/><p>Brian Hurlston <br/> (203) 292-1598</p>`}>
          Loan officer
        </Link>
        <Tooltip 
          id="loan-officer-tooltip"
          className='tooltip-button tooltip-button-loan-officer'
          place="left"
          openOnClick={true}
        />
        <span className="text">YOUR MAIN CONTACT</span>
        <p className="text text-bold">{name}</p>
        <div className="CardProfile__content--bottom">
          <Link to="./" className="text text-small">
            {email}
          </Link>
          <span className="text text-small">{phone}</span>
        </div>
      </div>

      {/* Mobile View */}
      <div className="CardProfile__content CardProfile__content--mobile">
        <p className="CardProfile__contact-label">
          Main Loan Contact: <span className="CardProfile__contact-name">{name}</span>
        </p>
        <p className="CardProfile__contact-info">
          {email} | {phone}
        </p>
      </div>
    </section>
  );
};
export default CardProfile;
